import { render, staticRenderFns } from "./birdIcon.vue?vue&type=template&id=471203ff&"
import script from "./birdIcon.vue?vue&type=script&lang=js&"
export * from "./birdIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports